import {apiSlice} from '@src/store/apiSlice';

/**
 * Métricas de uso de IA – endpoint na API admin.
 * GET /admin/ia/dashboard (basePath já inclui /v1/admin).
 */
export const aiCostsApi = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getAiCostsMetrics: builder.query({
            query: ({dateFrom, dateTo, view = 'summary', feature, modelId, limit, offset, account_id}) => {
                const params = new URLSearchParams();
                if (view) {
                    params.append('view', view);
                }
                if (dateFrom) {
                    params.append('date_from', dateFrom);
                }
                if (dateTo) {
                    params.append('date_to', dateTo);
                }
                if (feature) {
                    params.append('feature', feature);
                }
                if (modelId) {
                    params.append('model_id', modelId);
                }
                if (limit != null) {
                    params.append('limit', String(limit));
                }
                if (offset != null) {
                    params.append('offset', String(offset));
                }
                if (account_id != null) {
                    params.append('account_id', String(account_id));
                }

                return {url: `/ia/dashboard?${params.toString()}`};
            },
        }),
    }),
});

export const {useGetAiCostsMetricsQuery} = aiCostsApi;
